import { render } from "./RegisterTypeDeliveryOptions.vue?vue&type=template&id=88dab1fc"
import script from "./RegisterTypeDeliveryOptions.vue?vue&type=script&lang=js"
export * from "./RegisterTypeDeliveryOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QSelect,QTooltip});
